
	import { defineComponent, ref, watch, getCurrentInstance, onMounted, PropType } from 'vue'
	import { UsePageDto } from '@/common/mixins/listPageDto'
	import { useTableScroll } from '@/common/mixins/useTableScroll'
	import { seatColumns } from '../config'
	import { setAllSelect } from '@/common/mixins/setAllSelect'
	import { getSeatList } from '../../calloutLine/request'
	import toast from '@/common/functions/toast'

	export default defineComponent({
		props: {
			value: {
				type: Number,
				default: 1
			},
			appointValue: {
				type: Array as PropType<string[]>,
				default: () => []
			},
			name: {
				type: [String, Array],
				default: () => []
			},
			filter: {
				type: Object,
				default: () => ({})
			},
			num: {
				type: String,
				default: ''
			},
			required: {
				type: Boolean,
				default: false
			},
			size: {
				type: String,
				default: 'small'
			}
		},
		emits: ['update:appointValue', 'update:value'],
		setup(props, { emit }) {
			const seatNum = ref(1)
			const appointSeats: any = ref([])
			const visible = ref(false)
			const data = ref([])
			const { selectedRowKeys, rowSelection } = setAllSelect(data, 'seat')

			const instance = getCurrentInstance()
			const { scroll } = useTableScroll(instance)
			const { pagination, listPageDto, handleTableChange, refresh } = UsePageDto(instance)

			const loading = ref<boolean>(false)

			const changeSeatNum = (val) => {
				emit('update:value', val)
			}

			const confirmSeat = () => {
				if (selectedRowKeys.value.length > seatNum.value) {
					emit('update:value', selectedRowKeys.value.length)
				}
				emit('update:appointValue', selectedRowKeys.value || [])
				visible.value = false
			}

			const openSeatModal = () => {
				if (!props.num) {
					toast('请先选择线路')
					return
				}
				visible.value = true
			}

			// 获取列表
			const fetchList = async () => {
				if (!props.num) {
					return
				}
				const params = {
					num: props.num,
					pageDto: {
						pageNum: listPageDto.pageNum,
						pageSize: 100000
					}
				}
				loading.value = true
				try {
					const res = await getSeatList(params)
					loading.value = false
					data.value = res.data.map((item) => {
						return {
							...item,
							disabled: (Boolean(item.name) && !props.appointValue.some(sub => sub == item.seat))
						}
					})
				} catch (e) {
					loading.value = false
				}
			}

			watch(
				[() => props.value, () => props.appointValue],
				() => {
					seatNum.value = props.value
					appointSeats.value = props.appointValue
					if (!selectedRowKeys.value.length) {
						selectedRowKeys.value = props.appointValue
					}
				},
				{ deep: true, immediate: true }
			)

			watch(
				() => props.num,
				() => {
					if (props.num) {
						fetchList()
					}
				},
				{ deep: true, immediate: true }
			)

			onMounted(() => {
				fetchList()
			})

			return {
				seatNum,
				changeSeatNum,
				appointSeats,
				visible,
				confirmSeat,
				scroll,
				data,
				handleTableChange,
				pagination,
				fetchList,
				seatColumns,
				rowSelection,
				openSeatModal,
				loading
			}
		}
	})
